import ValidatedCheckbox from './ValidatedCheckbox';

export { Props } from './ValidatedCheckbox';
export default ValidatedCheckbox;
